import React, { FunctionComponent, MutableRefObject } from 'react';

import { useIntl } from 'react-intl';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// import SecondaryButton from '../../components/atoms/SecondaryButton';

import { ContentSection } from './components/Section';
import Logo from './components/Logo';
import { useMediaQueryContext } from '../../providers/MediaQueryProvider';

type SectionAbout = {
  sectionRef: MutableRefObject<null>;
};

const SectionAbout: FunctionComponent<SectionAbout> = ({ sectionRef }) => {
  const { width } = useMediaQueryContext();
  const { formatMessage } = useIntl();
  const section = 'about';

  return (
    <ContentSection
      sectionRef={sectionRef}
      alignment="right"
      supportContent={
        <Box textAlign="center" mb={width < 960 ? 5 : 0}>
          <img
            alt="Mock"
            src="./assets/mock-lg-2.png"
            width={400}
            style={{
              maxHeight: '400px',
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </Box>
      }
    >
      <Typography variant="h3">
        {formatMessage(
          { id: `${section}.title` },
          { logo: <Logo key="section.about.logo" /> }
        )}
      </Typography>
      <Box py={2}>
        <Typography color="textPrimary">
          {formatMessage({ id: `${section}.text` })}
        </Typography>
      </Box>
      {/* <SecondaryButton route="story" tabIndex={-1}>
        {formatMessage({ id: `${section}.button` })}
      </SecondaryButton> */}
    </ContentSection>
  );
};

export default SectionAbout;
